import React from 'react';
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonButtons,
  IonBackButton,
  IonContent,
  IonList,
  IonItem,
  IonLabel,
  IonIcon,
  useIonViewWillLeave,
} from '@ionic/react';
import { peopleOutline, notificationsOutline } from 'ionicons/icons';
import SnowballMenu from '@/modules/user/SnowballMenu';

const SettingsHome: React.FC = () => {
  useIonViewWillLeave(() => {
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }
  });

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonBackButton defaultHref="/topics" />
          </IonButtons>
          <IonTitle>Settings</IonTitle>
          <IonButtons slot="end">
            <SnowballMenu />
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>
        <IonList>
          <IonItem
            button
            detail
            routerLink="/settings/contacts"
            data-testid="settings-contacts-item"
          >
            <IonIcon icon={peopleOutline} slot="start" />
            <IonLabel>Address Book</IonLabel>
          </IonItem>
          <IonItem
            button
            detail
            routerLink="/settings/notifications"
            data-testid="settings-notifications-item"
          >
            <IonIcon icon={notificationsOutline} slot="start" />
            <IonLabel>Notifications</IonLabel>
          </IonItem>
        </IonList>
      </IonContent>
    </IonPage>
  );
};

export default SettingsHome;
